import { RESET_VALIDATION_ERROR, SET_VALIDATION_ERROR } from '../actionTypes';

export function validationErrors(state = {}, action) {
  switch (action.type) {
    case SET_VALIDATION_ERROR:
        return {
          ...state,
          ...action.errors
        }
    case RESET_VALIDATION_ERROR:
        return {}

    default:
      return state
  }
}
